import { makeStyles, Theme } from '@material-ui/core/styles'

export const useStyles = makeStyles<Theme>((theme) => ({
  promoImg: {
    width: '100%',
    marginBottom: '3.5rem'
  },
  tabTitle: {
    fontSize: '1rem',
    fontWeight: 600,
    marginBottom: 8,
    color: theme.palette.text.secondary
  },
  contentContainer: {
    width: '100%',
    marginTop: theme.spacing(2),
    marginBottom: 32
  },
  paragraph: {
    marginBottom: 16,
    fontSize: '1rem',
    lineHeight: 1.7,
    color: theme.palette.text.primary
  },
  tableContainer: {
    maxWidth: 600,
    margin: '0 auto'
  },
  dotList: {
    paddingLeft: 24,
    marginBottom: 24,

    '& li': {
      marginBottom: 12,
      fontSize: '1rem',
      lineHeight: 1.7,
      color: theme.palette.text.primary
    }
  }
}))
